// extracted by mini-css-extract-plugin
export default {"root":"IconSofa_root__h5Py4"};